import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconAlarmComponent } from "./med-icon-alarm.component";

@NgModule({
  declarations: [
    MedIconAlarmComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconAlarmComponent,
  ],
})
export class MedIconAlarmModule { }
